'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_api_UsersCreateRequestForm(user, organization) {
  this.uI = null;
  this.uH = null;
  this.uI = user;
  this.uH = organization;
}
export { $c_Lapp_api_UsersCreateRequestForm as $c_Lapp_api_UsersCreateRequestForm };
$p = $c_Lapp_api_UsersCreateRequestForm.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_api_UsersCreateRequestForm;
/** @constructor */
function $h_Lapp_api_UsersCreateRequestForm() {
}
export { $h_Lapp_api_UsersCreateRequestForm as $h_Lapp_api_UsersCreateRequestForm };
$h_Lapp_api_UsersCreateRequestForm.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_UsersCreateRequestForm)) {
    var x = this.uI;
    var x$2 = x$0.uI;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      return (this.uH === x$0.uH);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "UsersCreateRequestForm";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.uI;
  }
  if ((n === 1)) {
    return this.uH;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "user";
  }
  if ((n === 1)) {
    return "organization";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_api_UsersCreateRequestForm(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iz)));
}
export { $isArrayOf_Lapp_api_UsersCreateRequestForm as $isArrayOf_Lapp_api_UsersCreateRequestForm };
var $d_Lapp_api_UsersCreateRequestForm = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_api_UsersCreateRequestForm, "app.api.UsersCreateRequestForm", ({
  iz: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_api_UsersCreateRequestForm as $d_Lapp_api_UsersCreateRequestForm };
//# sourceMappingURL=app.api.-Users-Create-Request-Form.js.map
